// extracted by mini-css-extract-plugin
module.exports = {"weekday":"LocationTableCard_weekday__lGx5W","active":"LocationTableCard_active__1Rr5B"};